import { OnInit, Component, Input, SimpleChange, Output, EventEmitter } from '@angular/core';
// import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { TranslateService } from 'ng2-translate';
import uniq from 'lodash/uniq';
import get from 'lodash/get';
import { ResultListOption, ResultListTranslation, ResultListAction, ResultListColumn } from './models/result-list';

@Component({
    selector: 'my-result-list',
    templateUrl: './result-list.component.html',
    styleUrls: ['./result-list.component.scss']
})
export class ResultListComponent implements OnInit {

    constructor(private _translateService: TranslateService)
    // tslint:disable-next-line:one-line
    { }
    public filterValue: string;

    public options: ResultListOption = new ResultListOption({
        // Pagination
        limit: null,

        // Type de sélection (multi ou single ou falsey pour aucune)
        selectionType: 'falsey',

        // Permet l'edition des données d'une ligne de la table
        inlineEdit: false,

        // Permet de supprimmer une ligne de la table
        inlineDelete: false,

        // Permet d'ajouter une ligne de la table
        addRowEnabled: false,

        // Export
        exportEnabled: false,

        // Footer
        hasFooter: true,

        // Troncature de l'affichage des donnees des colonnes
        truncatureArgs: [],

        // Taille de la colonne des actions
        actionColumnWith: 100,

        // input recherche visible
        hasFilter: true
    });

    public editing = {};
    public translation: ResultListTranslation = new ResultListTranslation({
        emptyMessage: this._translateService.instant('result-list.notifications.no-data'),
        selectedMessage: this._translateService.instant('result-list.notifications.selected'),
        totalMessage: this._translateService.instant('result-list.notifications.total')
    });

    public filterPlaceholder: string = "";
    public filterResetButtonTooltip: string = "";

    private _rows: any[] = [];
    
    @Input() public identifier: string;
    @Input() public tableTitle: string;
    @Input() public arrayListSelected: any[] = [];
    @Input() public arrayListToDisplay: any[];
    @Input() public columnListToDisplay: ResultListColumn[];
    @Input() public actionList: ResultListAction[] = [];
    @Input() public paramOptions: any;
    @Output() public onSelectCallback: EventEmitter<any> = new EventEmitter();
    @Output() public onChangeCallback: EventEmitter<any> = new EventEmitter();
    @Output() public onSelectChangeCallback: EventEmitter<any> = new EventEmitter();
    @Input() public disabled: boolean = false;

    private _initialRowsList: any[] = [];

    public ngOnInit(): void {
        this._filterPlaceHolder();

        // TODO : Bricolage car pas de pipe translate disponible via le socle, à remplacer à la disparition du socle
        this.filterResetButtonTooltip = this._translateService.instant('result-list.notifications.reset');

        this._actionListSize();
    }

    public ngOnChanges(changes: SimpleChange) {
        if (changes['paramOptions']) {
            this.options = Object.assign({}, this.options, changes['paramOptions'].currentValue);
        } else if (changes['arrayListToDisplay']) {
            this._initialRowsList = changes['arrayListToDisplay'].currentValue;
            this.resetFilter();
        } else if (changes['columnListToDisplay']) {
            this._filterPlaceHolder();
        } else if (changes['actionList']) {
            this._actionListSize();
        }
    }

    private _filterPlaceHolder() {
        let columnFiltered: Array<String> = [];
        for (let item of this.columnListToDisplay) {
            if (item.filter && item.filter === true) {
                columnFiltered.push(item.name);
            }
        }
        if (columnFiltered.length > 0) {
            this.filterPlaceholder = (this._translateService.instant('result-list.notifications.research') + ' ' + columnFiltered.join(', ') + "...").replace('  ', ' ');
        }
    }

    private _actionListSize() {
        if (this.actionList.length > 0) {
            this.options.actionColumnWith = this.actionList.length * (10 + 20) + 1.25 * 12;

            if (this.options.actionColumnWith < 40) {
                this.options.actionColumnWith = 40;
            }
        }
    }

    public renderAction(item: any, name?: string) {
        if (typeof this.paramOptions != 'undefined' && typeof this.paramOptions['renderAction'] != 'undefined')
            return this.paramOptions['renderAction'](item, name);

        return true;
    }

    public actionCallback(item: any, action: any, params: Array<any>) {
        if (!action) {
            return;
        }
        // Si on reçoit le paramètre 'all' on envoit par defaut tout les paramètres
        if (params && params[0] == "all") {
            action(item);
        }
        else if (params) {
            let paramList = [];
            for (let param of params) {
                paramList.push(item[param]);
            }
            action(...paramList);
        } else {
            action();
        }
    }

    public onSelect(event) {
        this.arrayListSelected = event.selected;
        this.onSelectCallback.emit({ event: event, selected: this.arrayListSelected });
    }

    public preventSelect(event) {
        event.preventDefault();
        event.stopPropagation();
    }

    public edit(event, row, cell) {
        this.preventSelect(event);
        if (this.options.inlineEdit) {
            this.editing[row.$$index + '-' + cell] = true;
        }
    }

    public updateValue(event, cell, cellValue, row) {
        this.arrayListToDisplay[row.$$index][cell] = event.target.value;
        this.onChangeCallback.next({ resultList: this.arrayListToDisplay });
        delete this.editing[row.$$index + '-' + cell];
    }

    public changeValue(event) {
        this.onSelectChangeCallback.next( {'list-identifier': this.identifier, 'key': event.target.name, 'value': event.target.value} );
    }

    public deleteSelection() {
        this.editing = {};

        for (let row of this.arrayListSelected) {
            this.arrayListToDisplay.splice(row.$$index, 1);
        }
        this.onChangeCallback.next({ resultList: this.arrayListToDisplay });

        this.arrayListSelected.splice(0, this.arrayListSelected.length);
        this.onSelectCallback.emit({ event: event, selected: this.arrayListSelected });
    }

    public addRow() {
        // Nouvelle ligne
        let objectToAdd: any = {};
        for (let column of this.columnListToDisplay) {
            objectToAdd[column.prop] = '';
        }
        this.arrayListToDisplay.unshift(objectToAdd);
        this.onChangeCallback.next({ resultList: this.arrayListToDisplay });

        // On active l'edition de ce dernier element ajouté
        this.editing = {};

        // On change la sélection
        this.arrayListSelected.splice(0, this.arrayListSelected.length);
        this.arrayListSelected.push(objectToAdd);
        this.onSelectCallback.emit({ event: event, selected: this.arrayListSelected });

        /* Voici le problème, on observe l'edition d'un element via editing[(row.$$index).toString() + '-name']
            Cependant ce $$index n'est pas créé instantanément car je suppose que c'est un observable.
            Voila pourquoi la raison de ce timeout tout moche. J'ai déjà passé un peu de temps à chercher une autre solution
            plus simple et plus jolie mais, celle-ci dessous est la plus simple pour l'instant mais de loin la plus élégante
        */
        let that: any = this;
        setTimeout(function () {
            let row: any = that.arrayListToDisplay[0];
            if (row && that.options.inlineEdit) {
                that.editing[(row.$$index).toString() + '-' + that.columnListToDisplay[0].prop] = true;
            }
        }, 300);
    }

    public get filteredData(): any[] {
        if (!this.options.hasFilter || this.filterValue == undefined || this.filterValue == '') {
            return this.arrayListToDisplay;
        }
        let val: string = this.filterValue.toLowerCase();

        let filteredData: any[] = [];
        for (let item of this.columnListToDisplay) {
            if (item.filter && item.filter === true) {
                let columnId = item.prop;
                let listData = this._initialRowsList.filter(function (d) {
                    return d[columnId].toLowerCase().indexOf(val) !== -1 || !val;
                });
                filteredData.push(listData);
            }
        }

        // On fusionne les résultats retournés des différentes colonnes filtrées
        let concatArray = [].concat.apply([], filteredData);

        // On retire les duplicats en se basant sur l'index unique du tableau $$index
        return uniq(concatArray, '$$index');
    }

    public resetFilter() {
        this.filterValue = undefined;
    }

    public translate(value:string, row:any = undefined, params:any[] = []):string {
        let translateParams:any = {};
        
        if(row != undefined) {
            Object.keys(params).forEach(key => {
                translateParams[key] = get(row, params[key]);
            });
        }

        return value!=undefined?this._translateService.instant(value, translateParams):undefined;
    }
    
    public get(data:any, props:any, defaultValue:any):any {
        return get(data, props, defaultValue);
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/result-list/result-list.component.ts